/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { googleTranslate } from '../../scripts/translate.js';
// uncomment next line to enable Analytics
import ReactGA from 'react-ga';
// State management
import { connect } from 'react-redux';
import {
  setCurrentDocument,
  Search,
  findFirstPageWithContent,
  clearSearch,
} from '../../store/Document/documentActions';
// Styles
import './style.scoped.scss';
import $ from 'jquery';
import { FaArrowUp } from 'react-icons/fa';
import {
  addScrollEvent,
  notification,
  ROUTES,
  scrollToElement,
  setElementHeights,
  USER,
} from '../../assets/constants/strings.js';
// Components
import Header from '../../components/Header';
import HeaderBar from '../../components/HeaderBar';
import Footer from '../../components/Footer';
import LeftNav from '../../components/LeftNav';
import MainContent from '../../components/MainContent';
import RightNav from '../../components/RightNav';
import Loader from '../../components/Loader';
import SearchResult from '../../components/SearchResult';
import ErrorFrame from '../../components/Error';
import TopNav from '../../components/TopNav';
import Menu from '../../components/Menu/index';
import Comparison from '../../components/Comparison';
// Modals
import DocListModal from '../../components/DocList';
import GlossaryModal from '../../components/Modals/Glossary';
import AboutModal from '../../components/Modals/About';
import VersioningModal from '../../components/Modals/Versioning';
// import VideoModal from '../../components/Modals/Video';
import FAQModal from '../../components/Modals/FAQ';
import RevealrSummary from '../../components/RevealrSummary';
import VersionComparison from '../../components/VersionComparison';
import { UpdateUserUsage } from '../../store/Paddle/paddleActions.js';

const Document = ({
  document: currentDocument,
  glossaries,
  DocLoading,
  clientProccessesRunning,
  page,
  Search,
  searchResults,
  largePageLoading,
  setCurrentDocument,
  clearSearch,
  user,
  UpdateUserUsage,
}) => {
  const { docSlug, pageSlug, scrollItem } = useParams();

  const [scrollElement, setScrollElement] = useState({
    scrolled: false,
    targetID: null,
  });

  const [mainContentType, setMainContentType] = useState('main');
  const [searchKeyword, setSearchKeyword] = useState('');

  const [selectedLevel, setSelectedLevel] = useState(null);

  const [isRightNavVisible, setIsRightNavVisible] = useState(
    window.innerWidth > 950
  );

  const [comparisonDoc, setComparisonDoc] = useState(null);
  const [isAdvancedSearch, setIsAdvancedSearch] = useState(false);

  // previous Version
  const [selectedVersion, setSelectedVersion] = useState(null);

  const [FAQuestion, setFAQuestion] = useState(0);

  const [selectedGlossaryID, setSelectedGlossaryID] = useState(null);
  const [selectedGlossaryTerm, setSelectedGlossaryTerm] = useState(null);

  const [tooLong, setTooLong] = useState(false);

  // useEffect(() => {
  //   UpdateUserUsage(USER.USAGE.PAGEVIEWS);
  // }, []);

  useEffect(() => {
    const preventDefault = (event) => {
      event.preventDefault();
    };

    // Prevent selection
    document.addEventListener('selectstart', preventDefault);

    // Prevent copy
    document.addEventListener('copy', preventDefault);

    return () => {
      // Clean up event listeners when component unmounts
      document.removeEventListener('selectstart', preventDefault);
      document.removeEventListener('copy', preventDefault);
    };
  }, []);

  useEffect(() => {
    if (user) {
      // Google Analytics uncomment next line to enable
      ReactGA.initialize('UA-188442605-15');
      ReactGA.set({ userId: user.userID });
    }

    $(window).on('resize', setElementHeights);

    // if we have the param scrollItem
    if (scrollItem) {
      // save target ID
      if (!scrollElement.targetID) {
        setScrollElement((currentState) => ({
          ...currentState,
          targetID: scrollItem,
        }));
      }
    }

    return () => {
      $('.tooltip').remove();
    };
  }, []);

  useEffect(() => {
    if (!currentDocument) setCurrentDocument(docSlug, pageSlug);
    else if (currentDocument === 'Error') setTooLong(true);
  }, [currentDocument]);

  useEffect(() => {
    if (mainContentType !== 'main') {
      // prevent search frame from being changed if results are loading
      if (!(mainContentType === 'Search' && !searchResults))
        setMainContentType('main');
    }

    // if we havent scrolled to the selected element
    if (scrollElement.scrolled === false && scrollElement.targetID) {
      scrollToElement(scrollElement.targetID);
      setScrollElement({ scrolled: true, targetID: null });
    }
  }, [currentDocument]);

  useEffect(() => {
    googleTranslate();
    addScrollEvent();
    setElementHeights();

    ReactGA.pageview(window.location.pathname);

    // if (
    //   pageSlug &&
    //   pageSlug.length > 0 &&
    //   !window.location.href.match('localhost') &&
    //   user && !user.email.endsWith('@1wordflow.info')
    // )
    //   ReactGA.pageview(window.location.pathname);
  });

  useEffect(() => {
    if (DocLoading || clientProccessesRunning !== 0) {
      setTimeout(() => {
        if (
          (DocLoading || clientProccessesRunning !== 0) &&
          document.getElementById('extra-load-text')
        ) {
          document.getElementById('extra-load-text').innerText =
            'This is taking longer than usual...';
        }
      }, 45000);
      setTimeout(() => {
        if (
          currentDocument === null &&
          !page &&
          clientProccessesRunning === 0 &&
          document.getElementById('extra-load-text')
        ) {
          setTooLong(true);
        }
      }, 60000);
    }
  }, [DocLoading, clientProccessesRunning]);

  if (
    !user ||
    (user && !user.isActive)
    // (user &&
    //   !(user.accountStatus === 'trialing' || user.accountStatus === 'active'))
  ) {
    return <Redirect to={ROUTES.LOGIN} />;
  }
  // page/URL behaviors
  if (tooLong) {
    // something went wrong and the app took more than a minute to get rid of loading frame
    return (
      <div className='page-loader-wrapper'>
        <ErrorFrame />
      </div>
    );
  } else if (
    !(clientProccessesRunning === 0 || clientProccessesRunning === 100) ||
    currentDocument === null ||
    !page ||
    DocLoading
  ) {
    // default load state
    return (
      <div className='page-loader-wrapper'>
        <Loader />
      </div>
    );
  } else if (
    !pageSlug &&
    currentDocument &&
    currentDocument.pages &&
    currentDocument.pages.length > 0
  ) {
    // user opened document by only providing document reference, we need to determine the page
    try {
      const correctSlug = findFirstPageWithContent(currentDocument.pages).slug;
      return (
        <Redirect
          to={`/app/${docSlug}/${correctSlug}${
            scrollItem && scrollItem.length > 0 ? `/${scrollItem}` : ''
          }`}
        />
      );
    } catch (e) {
      // failed to find page through function, just return first page present
      // console.log('could not find specified document in state,', e.message);
      return (
        <Redirect
          to={`/app/${docSlug}/${currentDocument.pages[0].slug}${
            scrollItem && scrollItem.length > 0 ? `/${scrollItem}` : ''
          }`}
        />
      );
    }
  } else if (
    currentDocument &&
    docSlug.toLowerCase() !== currentDocument.slug
  ) {
    // found document but it is not reflected properly on URL
    return (
      <Redirect
        to={`/app/${currentDocument.slug}${
          pageSlug && pageSlug.length > 0 ? `/${pageSlug}` : ''
        }${scrollItem && scrollItem.length > 0 ? `/${scrollItem}` : ''}`}
      />
    );
  } else if (
    page &&
    pageSlug.toLowerCase() !== page.slug &&
    currentDocument.pages &&
    !currentDocument.pages.some((page) => page.slug === pageSlug)
  ) {
    // found page from document but it is not reflected properly on URL
    return (
      <Redirect
        to={`/app/${currentDocument.slug}/${page.slug}${
          scrollItem && scrollItem.length > 0 ? `/${scrollItem}` : ''
        }`}
      />
    );
  } else if (
    (docSlug && docSlug.match(/[A-Z]/g)) ||
    (pageSlug && pageSlug.match(/[A-Z]/g))
  ) {
    // if User types as document name appears, with upper case, redirect to lower case
    return (
      <Redirect
        to={`/app/${docSlug.toLowerCase()}/${pageSlug.toLowerCase()}${
          scrollItem && scrollItem.length > 0 ? `/${scrollItem}` : ''
        }`}
      />
    );
  }

  const handleSetFAQ = (question) => {
    setFAQuestion(question);
    $('#FAQModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const handleGlossarySelected = (ID, key) => {
    setSelectedGlossaryTerm(key);
    setSelectedGlossaryID(ID);
    $('#glossaryModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const handlePageChange = (type, searchKey) => {
    if (mainContentType === 'Search' && type !== 'Search') {
      // if going away from search, clear results
      clearSearch();
    }

    if (type === 'Search') {
      setMainContentType(type);
      setSearchKeyword(searchKey);
      Search(searchKey);
    } else if (type === 'Glossary') {
      setSelectedGlossaryTerm(null);
      $('#glossaryModal').modal('show');
    } else if (type === 'About') {
      $('#aboutModal').modal('show');
    } else if (type === 'AboutVideo') {
      $('#videoModal').modal('show');
    } else setMainContentType(type);

    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const handleComparisonDocument = (document) => {
    setComparisonDoc(document);
    handlePageChange('Comparison');
  };

  const handleVersionComparison = (document) => {
    setComparisonDoc(document);
    handlePageChange('Version');
  };

  const pageMainContent = (type) => {
    switch (type) {
      case 'main': {
        return largePageLoading ? (
          <div className='inner-load'>
            <Loader />
          </div>
        ) : (
          <MainContent
            currentDocument={currentDocument}
            handlePageChange={handlePageChange}
            handleDisplayGlossary={handleGlossarySelected}
          />
        );
      }
      case 'Search': {
        return (
          <SearchResult
            searchKeyword={searchKeyword}
            isAdvanced={isAdvancedSearch}
            handleClose={() => handlePageChange('main')}
            handleTagSelected={handleSearch}
          />
        );
      }
      case 'Comparison': {
        return (
          <Comparison
            leftDocument={currentDocument}
            rightDocument={comparisonDoc}
            handleCloseComparison={() => {
              handlePageChange('main');
            }}
          />
        );
      }
      case 'Version': {
        return (
          <VersionComparison
            currentDocument={currentDocument}
            docToCompare={comparisonDoc}
            handleCloseComparison={() => {
              handlePageChange('main');
            }}
          />
        );
      }

      case 'Summary': {
        return (
          <RevealrSummary
            handleCloseSummary={() => {
              handlePageChange('main');
            }}
            currentDoc={currentDocument}
            handleDisplayGlossary={handleGlossarySelected}
          />
        );
      }

      default:
        return null;
    }
  };

  const handleSearch = (input, isAdvanced) => {
    setIsAdvancedSearch(isAdvanced);
    // if the input is not an empty string
    if (input.replace(/\s|s|S/g, '').length !== 0) {
      handlePageChange('Search', input);
    } else alert('Invalid search value');
  };

  const handleDismissGlossary = () => {
    setSelectedGlossaryTerm(null);
    setSelectedGlossaryID(null);
  };

  const handleRightNav = (visible) => {
    setIsRightNavVisible(visible);
  };

  //#region MODAL BEHAVIOURS

  const handleLevelSelected = (value, level = 'levelOne') => {
    setSelectedLevel({
      value: value,
      level: level,
    });
    $('#DocsListModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const handleOnDismiss = () => {
    setSelectedLevel(null);
  };

  const handlePreviousVersion = (document) => {
    setSelectedVersion(document);
    $('#versioningModal').modal('show');
    $('.modal-backdrop').appendTo('#wf-doc-page');
  };

  const hideVersionModal = (shouldHide = true) => {
    setSelectedVersion(null);
    if (shouldHide) $('#versioningModal').modal('hide');
  };

  const handleSummary = (value) => {
    if (user.remainingSummaries <= 0 && mainContentType !== 'Summary') {
      return notification(
        'info',
        'You have reached your amount of summaries for the current period.'
      );
    }
    setMainContentType(value);
  };

  //#endregion

  if (user.remainingPageViews <= 0) {
    return <ErrorFrame />;
  }

  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <Header hasNav handleLevelSelected={handleLevelSelected} />

          <TopNav handleLevelSelected={handleLevelSelected} />

          {mainContentType !== 'Comparison' && (
            <HeaderBar
              handleSearch={handleSearch}
              backGoesHome={true}
              handleLevelSelected={handleLevelSelected}
              contentType={mainContentType}
            />
          )}
        </div>
      </nav>

      <main role='main' className='wf-document px-0 mb-0' id='wf-document'>
        <LeftNav
          handlePageChange={handlePageChange}
          contentType={mainContentType}
        />

        <div id='main-content' className='col pl-4 mr-4'>
          {pageMainContent(mainContentType)}
        </div>

        <RightNav
          handleComparisonDocument={handleComparisonDocument}
          contentType={mainContentType}
          handleSetFAQ={handleSetFAQ}
          handleVisibility={handleRightNav}
          handleGlossarySelected={handleGlossarySelected}
          handlePreviousVersion={handlePreviousVersion}
          handleSummary={handleSummary}
        />

        {!isRightNavVisible && (
          <Menu
            handlePageChange={handlePageChange}
            handleComparisonDocument={handleComparisonDocument}
            contentType={mainContentType}
            handleSetFAQ={handleSetFAQ}
            handlePreviousVersion={handlePreviousVersion}
            handleSummary={handleSummary}
          />
        )}

        <div
          id='scroll-top'
          className='scroll-to-top-wrapper'
          onClick={() => {
            $('#main-content').scrollTop(0);
            $('#wf-scroll-wrapper').scrollTop(0);
          }}
        >
          <div className='scroll-to-top'>
            <FaArrowUp />
          </div>
        </div>
      </main>
      <Footer isDocument isAbsolute />

      <DocListModal
        isDocument
        selectedLevel={selectedLevel}
        onDismiss={handleOnDismiss}
      />

      <FAQModal question={FAQuestion} />
      <AboutModal handleDismiss={() => $('#aboutModal').modal('hide')} />
      {/* <VideoModal /> */}
      {glossaries && (
        <GlossaryModal
          selectedKey={selectedGlossaryTerm}
          selectedGlossaryID={selectedGlossaryID}
          handleDismiss={handleDismissGlossary}
        />
      )}
      <VersioningModal
        currentDocument={currentDocument}
        previousDocument={selectedVersion}
        onDismiss={hideVersionModal}
        handleComparison={handleVersionComparison}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  documents: state.client.documents,
  DocLoading: state.document.loading,
  clientProccessesRunning: state.client.proccessesRunning,
  largePageLoading: state.document.largePageLoading,
  document: state.document.currentDocument,
  page: state.document.currentPage,
  searchResults: state.document.searchResults,
  glossaries: state.client.glossaryList,
  user: state.user.user,
});

const mapDispatchToProps = {
  setCurrentDocument,
  Search,
  clearSearch,
  UpdateUserUsage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(Document);
